import { useState } from "react";
import ImageCrop, { ImageSize } from "./ImageCrop";

export type CropOptions = {
  title: string;
  cropSize: ImageSize;
  previewSize: ImageSize;
  minZoom?: number;
  maxZoom?: number;
};

type ImageCallback = (image: Blob) => void;

const useImageCrop = (
  title?: string,
  cropSize?: ImageSize,
  previewSize?: ImageSize,
  minZoom?: number,
  maxZoom?: number
) => {
  const [callback, setCallback] = useState<ImageCallback>();
  const [sourceImage, setSourceImage] = useState<File | undefined>();

  const startCrop = (image: File, callback: ImageCallback) => {
    setSourceImage(image);
    setCallback(() => callback);
  };

  return {
    startCrop,
    cropElement:
      sourceImage !== undefined ? (
        <ImageCrop
          title={title}
          sourceImage={sourceImage}
          size={{
            crop: cropSize,
            preview: previewSize
          }}
          minZoom={minZoom}
          maxZoom={maxZoom}
          onCancel={() => setSourceImage(undefined)}
          onSubmit={value => {
            setSourceImage(undefined);
            if (callback) {
              callback(value);
            } else {
              console.log("No callback");
            }
          }}
        />
      ) : undefined
  };
};

export default useImageCrop;
